module.exports = __webpack_public_path__ + "static/media/central-main.f27cd9fe.svg";